import axios from "axios";
import { useCallback } from "react";

const useWithdrawal = (onLogout) => {
  const handleWithdrawal = useCallback(async () => {
    const confirmation = window.confirm("정말로 회원탈퇴 하시겠습니까?");
    if (!confirmation) return;

    try {
      const response = await axios.delete("/api/user", {
        withCredentials: true, // 쿠키 인증
      });

      if (response.status === 200) {
        alert("회원탈퇴가 완료되었습니다.");
        if (onLogout) onLogout(); // 로그아웃 호출
      } else {
        alert("회원탈퇴에 실패했습니다. 다시 시도해주세요.");
      }
    } catch (error) {
      alert("오류가 발생했습니다. 나중에 다시 시도해주세요.");
      console.error(error);
    }
  }, [onLogout]);

  return { handleWithdrawal };
};

export default useWithdrawal;
